import React, { useState, FormEvent, useContext, useEffect } from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';
import { IBdodJob } from "../../../app/models/bdodjob";
import BdodJobStore from "../../../app/stores/bdodjobsStore";
import { observer } from 'mobx-react-lite';
import { RouteComponentProps } from 'react-router';

interface DetailParams {
    id: string;
}

const BdodJobEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
    match,
    history
  }) => {
      const bdodJobStore = useContext(BdodJobStore);
      const {editBdodJob, submitting, loadBdodJob, clearBdodJob} = bdodJobStore;

      const [bdodjob, setBdodJob] = useState<IBdodJob>({
          id: '',
          createdAt: '',
          updatedAt: '',
          workNumber:'',
          location:'',
          date:'',
          tech: '',
          status:'',
          payment: '',
          amount: 0,
          remark: ''
      });

      useEffect(() => {
          loadBdodJob(match.params.id).then(bdodjob => {setBdodJob(bdodjob);});
          return () => {
              clearBdodJob();
          }
      }, [loadBdodJob]);

      const statusOptions = [
        { key: "Complete", text: "Complete", value: "Complete" },
        { key: "In Progress", text: "In Progress", value: "In Progress" },
        { key: "New Job", text: "New Job", value: "New Job" },
      ];

      const paymentOptions = [{ key: "Paid", text: "Paid", value: "Paid" },
      { key: "Unpaid", text: "Unpaid", value: "Unpaid" },];

      const handleSubmit = () => {
          editBdodJob(bdodjob).then(() => history.push(`/financemanagement/bdodjob`));
      };

      const handleInputChange = (event : FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          const {name, value} = event.currentTarget;
          setBdodJob({...bdodjob, [name]: value});
      };
      return (
        <Segment clearing>
          <Form onSubmit={handleSubmit}>
          <Form.Input
              label='Work Number'
              onChange={handleInputChange}
              name='workNumber'
              placeholder='Work Number'
              value={bdodjob.workNumber}
            />
            <Form.Input
              label='Location'
              onChange={handleInputChange}
              name='location'
              placeholder='Location'
              value={bdodjob.location}
            />
            <Form.Input
              label='Date'
              onChange={handleInputChange}
              name='date'
              type='date'
              placeholder='Date'
              value={bdodjob.date}
            />
            <Form.Input
              label='Tech'
              onChange={handleInputChange}
              name='tech'
              placeholder='Tech'
              value={bdodjob.tech}
            />
            <Form.Select
              label='Status'
              onChange={(e, { name, value }) =>
                setBdodJob({ ...bdodjob, [name]: value })
              }
              name='status'
              placeholder='Status'
              options={statusOptions}
              value={bdodjob.status}
            />
            <Form.Select
              label='Payment'
              onChange={(e, { name, value }) =>
                setBdodJob({ ...bdodjob, [name]: value })
              }
              name='payment'
              placeholder='Payment'
              options={paymentOptions}
              value={bdodjob.payment}
            />
            <Form.Input
              label='Amount'
              onChange={handleInputChange}
              name='amount'
              placeholder='Amount'
              type='number'
              value={bdodjob.amount}
            />
            <Form.Input
              label='Remark'
              onChange={handleInputChange}
              name='remark'
              placeholder='Remark'
              value={bdodjob.remark}
            />
            <Button
              loading={submitting}
              floated='right'
              positive
              type='submit'
              content='Submit'
            />
            <Button
              onClick={() => history.push('/financemanagement/fttbhour')}
              floated='right'
              type='button'
              content='Cancel'
            />
          </Form>
        </Segment>
      );
    }

    export default observer(BdodJobEditForm);